import router from '@/router';
import store from '@/store/index';

const getDefaultState = () => {
  return {
    accessToken: '',
    refreshToken: '',
    userOrganId: '',
    userOrganTargetType: '',
    districtCode: '',
    districtName: '',
    userOrganTargetId: '',
    userOrganTargetName: '',
    userOrganPasswordModify: null,
    business: null,
    schoolEmail: null,
    hospitalVideoEdu: null,
    hospitalType: null,
    cityType: null,
    healthCareType: null,
    healthCareList: null,
    surveyCheck: null,
    selfCheckListIsDone: null,
    adminOrganType: '', // 관리자 : AD, 기관 : ALL
    deldate: null,
    registrationAvailable: null,
    notificationIsMade: null,
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetUserState(state) {
      Object.assign(state, getDefaultState());
    },
    setLoginUserInfo(state, payload) {
      Object.assign(state, payload);
    },
    setAccessToken(state, payload) {
      state.accessToken = payload;
    },
    setUserOrganPasswordModify(state, payload) {
      state.userOrganPasswordModify = payload;
    },
    setSchoolEmail(state, payload) {
      state.schoolEmail = payload;
    },
    setHospitalVideoEdu(state, payload) {
      state.hospitalVideoEdu = payload;
    },
    setSurveyCheck(state, payload) {
      state.surveyCheck = payload;
    },
    setHealthCareSurveyId(state, payload) {
      state.healthCareList.find(healthCare => healthCare.districtCode === payload.districtCode).healthCareSurveyId = payload.healthCareSurveyId;
    },
    setSelfCheckListIsDone(state, payload) {
      state.selfCheckListIsDone = payload;
    },
    setNotificationIsMade(state, payload) {
      state.notificationIsMade = payload;
    },
    setRegistrationAvailable(state, payload) {
      state.registrationAvailable = payload;
    },
  },
  actions: {
    updateInfo({ commit }, payload) {
      commit('setLoginUserInfo', payload);
      localStorage.setItem('adminOrganType', payload.adminOrganType);
      localStorage.setItem('accessToken', payload.accessToken);
      localStorage.setItem('refreshToken', payload.refreshToken);
    },
    logout({ state, commit }) {
      const adminOrganType = state.adminOrganType ? state.adminOrganType : localStorage.getItem('adminOrganType');
      commit('resetUserState');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      commit('popup/popupClear', null, { root: true });
      router.push(adminOrganType === 'AD' ? '/login/admin' : '/login').catch(() => {});
    },
  },
  getters: {
    districtCodeFirst(state) {
      return state.districtCode.charAt(0);
    },
    regionName(state) {
      const districtCodeFirst = state.districtCode.charAt(0);
      switch (districtCodeFirst) {
        case 'A':
          return '서울';
        case 'B':
          return '인천';
        case 'C':
          return '경기';
        case 'D':
          return '부산';
        case 'E':
          return '순천';
        case 'F':
          return '밀양';
        case 'G':
          return '수원';
        case 'I':
          return '전북';
        case 'J':
          return '울산';
        default:
          return '';
      }
    },
    organType(state) {
      switch (state.userOrganTargetType) {
        case 'CT':
          return '지자체 관리자';
        case 'HC':
          return '보건소';
        case 'HP':
          return '병원';
        case 'SC':
          return '학교';
        case 'CE':
          return '센터';
        default:
          return '';
      }
    },
    secondHealthCareList(state) {
      return state.healthCareList?.filter(healthCare => healthCare.healthCareDepth === 2);
    },
    healthCareSurveyCheck(state) {
      const healthCareList = store.getters['user/secondHealthCareList'].length > 0 ? store.getters['user/secondHealthCareList'] : state.healthCareList;
      return healthCareList.filter(healthCare => !healthCare.healthCareSurveyId).length === 0;
    },
  },
};
